export default function dateDiff(date1, date2) {
  const firstDate = new Date(date1);
  firstDate.setHours(0, 0, 0, 0);
  const secondDate = new Date(date2);
  secondDate.setHours(0, 0, 0, 0);
  const diffDays = Math.floor((secondDate.getTime() - firstDate.getTime()) / (24 * 60 * 60 * 1000));
  return diffDays;
}
